const styles = theme => ({
  container: {
    position: "relative",
    width: 400,
    padding: [[32, 16]],
    fontSize: "0.875rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  header: {
    textTransform: "uppercase",
    marginBottom: 16
  },
  emptyMessage: {
    marginBottom: 16
  },
  row: {
    display: "flex",
    marginRight: 16,
    margin: [[32, 0]],
    "&>p": {
      lineHeight: "1.4em",
      fontSize: "0.875rem",
      fontWeight: 500,
      textTransform: "uppercase",
      "&:first-child": {
        flex: 1
      }
    }
  },
  closeBtn: {
    fontSize: 28,
    cursor: "pointer",
    position: "absolute",
    top: "16px",
    right: "16px",
    "&:hover": {
      opacity: 0.9
    },
    "&:focus": {
      outline: "none"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 24
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Cart/styles.js